module.exports = __webpack_public_path__ + "img/hero-background2.89c05a49.png";